import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "letters" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "letter" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "恋爱自愈量表"),
  /*#__PURE__*/_createElementVNode("p", null, " 缘梦的建立是为帮助认识自己，及解决人与人之间的心理、相处、认知等问题； "),
  /*#__PURE__*/_createElementVNode("p", null, "提供恋爱自愈量表目的是，帮助恋爱中，遇到困难的找不到方向的你；"),
  /*#__PURE__*/_createElementVNode("p", null, " 只要您认真填写内容（即使不提交），大部分朋友都能通过量表找到解决思路； "),
  /*#__PURE__*/_createElementVNode("p", null, "害怕打字麻烦吗？你可以通过手机语音识别文字方式输入内容；"),
  /*#__PURE__*/_createElementVNode("p", { style: {"color":"#2992ff"} }, "互助互勉，我愿与您在缘梦中共同成长。")
], -1)
const _hoisted_3 = { class: "wrapperMax" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("你本次希望"),
  /*#__PURE__*/_createElementVNode("b", { style: {"color":"red"} }, "我们提供什么帮助"),
  /*#__PURE__*/_createTextVNode("：")
], -1)
const _hoisted_5 = { class: "wrapper" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "1.名字：", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "2.联系方式：", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "3.职业：", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "4.所在地区：", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "lh32 mr10" }, "5.年龄：", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "lh32 mr10" }, "6.身高(cm)：", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "7.容貌(10分制)：", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "8.性格(简述)：", -1)
const _hoisted_14 = { class: "wrapperMax" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "minW100" }, "9.教育程度：", -1)
const _hoisted_16 = { class: "wrapperMax" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("10.你的业余"),
  /*#__PURE__*/_createElementVNode("b", null, "爱好"),
  /*#__PURE__*/_createTextVNode("和"),
  /*#__PURE__*/_createElementVNode("b", null, "朋友圈"),
  /*#__PURE__*/_createTextVNode("子：")
], -1)
const _hoisted_18 = { class: "wrapperMax" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("11.你觉得自己的"),
  /*#__PURE__*/_createElementVNode("b", null, "优点"),
  /*#__PURE__*/_createTextVNode("有哪些：")
], -1)
const _hoisted_20 = { class: "wrapperMax" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("12.你觉得自己的"),
  /*#__PURE__*/_createElementVNode("b", null, "缺点"),
  /*#__PURE__*/_createTextVNode("有哪些：")
], -1)
const _hoisted_22 = { class: "wrapperMax" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("13.你觉得"),
  /*#__PURE__*/_createElementVNode("b", { style: {"color":"red"} }, "你们出现问题的原因是"),
  /*#__PURE__*/_createTextVNode("：")
], -1)
const _hoisted_24 = { class: "wrapper" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("14."),
  /*#__PURE__*/_createElementVNode("b", null, "对方"),
  /*#__PURE__*/_createTextVNode("职业：")
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("15."),
  /*#__PURE__*/_createElementVNode("b", null, "对方"),
  /*#__PURE__*/_createTextVNode("所在地区：")
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "lh32 mr10" }, [
  /*#__PURE__*/_createTextVNode("16."),
  /*#__PURE__*/_createElementVNode("b", null, "对方"),
  /*#__PURE__*/_createTextVNode("年龄：")
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "lh32 mr10" }, [
  /*#__PURE__*/_createTextVNode("17."),
  /*#__PURE__*/_createElementVNode("b", null, "对方"),
  /*#__PURE__*/_createTextVNode("身高(cm)：")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("18."),
  /*#__PURE__*/_createElementVNode("b", null, "对方"),
  /*#__PURE__*/_createTextVNode("容貌(10分制)：")
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("19."),
  /*#__PURE__*/_createElementVNode("b", null, "对方"),
  /*#__PURE__*/_createTextVNode("性格(简述)：")
], -1)
const _hoisted_31 = { class: "wrapperMax" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("20.对方的"),
  /*#__PURE__*/_createElementVNode("b", null, "业余爱好"),
  /*#__PURE__*/_createTextVNode("和"),
  /*#__PURE__*/_createElementVNode("b", null, "朋友圈"),
  /*#__PURE__*/_createTextVNode("子：")
], -1)
const _hoisted_33 = { class: "wrapperMax" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("21.对方喜欢的"),
  /*#__PURE__*/_createElementVNode("b", null, "食物零食、书籍和杂志、歌曲"),
  /*#__PURE__*/_createTextVNode("：")
], -1)
const _hoisted_35 = { class: "wrapper" }
const _hoisted_36 = { class: "wrapperMax" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("22."),
  /*#__PURE__*/_createElementVNode("b", null, "被拉黑的"),
  /*#__PURE__*/_createTextVNode("社交软件（选填）：")
], -1)
const _hoisted_38 = { class: "wrapperMax" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("23."),
  /*#__PURE__*/_createElementVNode("b", null, "仍可和对方联系的方式"),
  /*#__PURE__*/_createTextVNode("（选填）：")
], -1)
const _hoisted_40 = { class: "wrapperMax" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("24.你们"),
  /*#__PURE__*/_createElementVNode("b", null, "一共的约会次数和频率"),
  /*#__PURE__*/_createTextVNode("：")
], -1)
const _hoisted_42 = { class: "wrapperMax" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", null, "25.你和目标约会相处经常做的事情：", -1)
const _hoisted_44 = { class: "wrapperMax" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("26."),
  /*#__PURE__*/_createElementVNode("b", null, "不见面的时候"),
  /*#__PURE__*/_createTextVNode("用什么沟通最多：")
], -1)
const _hoisted_46 = { class: "wrapperMax" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("27.你们的"),
  /*#__PURE__*/_createElementVNode("b", null, "话题深入"),
  /*#__PURE__*/_createTextVNode("情况：")
], -1)
const _hoisted_48 = { class: "wrapperMax" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("28.你们是否"),
  /*#__PURE__*/_createElementVNode("b", null, "为对方哭过"),
  /*#__PURE__*/_createTextVNode("：")
], -1)
const _hoisted_50 = { class: "wrapper" }
const _hoisted_51 = { class: "wrapperMax" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", null, "29.你们的身体接触程度：", -1)
const _hoisted_53 = { class: "wrapperMax" }
const _hoisted_54 = { class: "wrapperMax" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", null, "31.是否有竞争者出现：", -1)
const _hoisted_56 = { class: "wrapperMax" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", null, "32.是否做过伤害对方的事情：", -1)
const _hoisted_58 = { class: "wrapperMax" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("33."),
  /*#__PURE__*/_createElementVNode("b", { style: {"color":"red"} }, "你对缘梦的认识程度"),
  /*#__PURE__*/_createTextVNode("：")
], -1)
const _hoisted_60 = { class: "wrapperMax" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("34."),
  /*#__PURE__*/_createElementVNode("b", { style: {"color":"red"} }, "您期待的解答时间是"),
  /*#__PURE__*/_createTextVNode("：")
], -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("b", null, "日期", -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("b", null, "时间", -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", { class: "lettermimo" }, "*这里设立的提交通道，仅为非学员求助通道，老师将利用（自己的休息时间）进行解答。提交成功后，助理将会通过您提供的（微信/邮箱/电话）与你联系，如老师无法在您期待的解答时间与您沟通，助理将会与您协商变更的预约时间，尽可能的给您提供帮助。", -1)
const _hoisted_65 = { class: "wrapperMax" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_a_form, {
      model: _ctx.formState,
      "label-col": _ctx.labelCol,
      "wrapper-col": _ctx.wrapperCol
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_a_textarea, {
            rows: 1,
            value: _ctx.formState.string[0],
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.string[0]) = $event)),
            placeholder: "具体需要我们做的或者特别需要我们提供的",
            maxlength: 100,
            "show-count": ""
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _hoisted_6,
            _createVNode(_component_a_input, {
              value: _ctx.formState.string[1],
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.string[1]) = $event)),
              maxlength: 10,
              "show-count": "",
              placeholder: "昵称"
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", null, [
            _hoisted_7,
            _createVNode(_component_a_input, {
              value: _ctx.formState.string[2],
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.string[2]) = $event)),
              maxlength: 40,
              placeholder: "电话/微信/Email",
              "show-count": ""
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", null, [
            _hoisted_8,
            _createVNode(_component_a_input, {
              value: _ctx.formState.string[3],
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.string[3]) = $event)),
              maxlength: 10,
              "show-count": "",
              placeholder: "学生/医生/文员..."
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", null, [
            _hoisted_9,
            _createVNode(_component_a_input, {
              value: _ctx.formState.string[4],
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.string[4]) = $event)),
              maxlength: 10,
              "show-count": "",
              placeholder: "省/市"
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", null, [
            _hoisted_10,
            _createVNode(_component_a_input, {
              value: _ctx.formState.string[5],
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.string[5]) = $event)),
              max: 99,
              type: "number",
              placeholder: "周岁"
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", null, [
            _hoisted_11,
            _createVNode(_component_a_input, {
              value: _ctx.formState.string[6],
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formState.string[6]) = $event)),
              max: 250,
              type: "number",
              placeholder: "cm"
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", null, [
            _hoisted_12,
            _createVNode(_component_a_input, {
              value: _ctx.formState.string[7],
              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formState.string[7]) = $event)),
              max: 10,
              type: "number",
              placeholder: "容貌自评得分"
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", null, [
            _hoisted_13,
            _createVNode(_component_a_input, {
              value: _ctx.formState.string[8],
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formState.string[8]) = $event)),
              maxlength: 30,
              "show-count": ""
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode(_component_a_radio_group, {
            value: _ctx.formState.string[9],
            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formState.string[9]) = $event)),
            class: "lh32"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio, {
                value: "初中或以下",
                name: "type"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("初中或以下")
                ]),
                _: 1
              }),
              _createVNode(_component_a_radio, {
                value: "高中",
                name: "type"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("高中")
                ]),
                _: 1
              }),
              _createVNode(_component_a_radio, {
                value: "大专",
                name: "type"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("大专")
                ]),
                _: 1
              }),
              _createVNode(_component_a_radio, {
                value: "本科",
                name: "type"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("本科")
                ]),
                _: 1
              }),
              _createVNode(_component_a_radio, {
                value: "硕士或以上",
                name: "type"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("硕士或以上")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createVNode(_component_a_textarea, {
            rows: 1,
            value: _ctx.formState.string[10],
            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formState.string[10]) = $event)),
            placeholder: "爱好：\n朋友圈子：",
            maxlength: 200,
            "show-count": ""
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createVNode(_component_a_textarea, {
            rows: 1,
            value: _ctx.formState.string[11],
            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formState.string[11]) = $event)),
            placeholder: "优点：",
            maxlength: 200,
            "show-count": ""
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createVNode(_component_a_textarea, {
            rows: 1,
            value: _ctx.formState.string[12],
            "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formState.string[12]) = $event)),
            placeholder: "缺点：",
            maxlength: 200,
            "show-count": ""
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createVNode(_component_a_textarea, {
            rows: 3,
            value: _ctx.formState.string[13],
            "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formState.string[13]) = $event)),
            placeholder: "双方之间的问题：怎么在一起的，交往过程中，现状，你的期望，疑问，已分手填写分手原因等等，越详细越好",
            maxlength: 500,
            "show-count": ""
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", null, [
            _hoisted_25,
            _createVNode(_component_a_input, {
              value: _ctx.formState.string[14],
              "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formState.string[14]) = $event)),
              maxlength: 10,
              "show-count": "",
              placeholder: "学生/医生/文员..."
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", null, [
            _hoisted_26,
            _createVNode(_component_a_input, {
              value: _ctx.formState.string[15],
              "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formState.string[15]) = $event)),
              maxlength: 10,
              "show-count": "",
              placeholder: "省/市"
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", null, [
            _hoisted_27,
            _createVNode(_component_a_input, {
              value: _ctx.formState.string[16],
              "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formState.string[16]) = $event)),
              max: 99,
              type: "number",
              placeholder: "周岁"
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", null, [
            _hoisted_28,
            _createVNode(_component_a_input, {
              value: _ctx.formState.string[17],
              "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formState.string[17]) = $event)),
              max: 250,
              type: "number",
              placeholder: "cm"
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", null, [
            _hoisted_29,
            _createVNode(_component_a_input, {
              value: _ctx.formState.string[18],
              "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formState.string[18]) = $event)),
              max: 10,
              type: "number",
              placeholder: "容貌自评得分"
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", null, [
            _hoisted_30,
            _createVNode(_component_a_input, {
              value: _ctx.formState.string[19],
              "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formState.string[19]) = $event)),
              maxlength: 200,
              "show-count": ""
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createVNode(_component_a_textarea, {
            rows: 1,
            value: _ctx.formState.string[20],
            "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formState.string[20]) = $event)),
            placeholder: "爱好：\n朋友圈子：",
            maxlength: 300,
            "show-count": ""
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _createVNode(_component_a_textarea, {
            rows: 2,
            value: _ctx.formState.string[21],
            "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formState.string[21]) = $event)),
            placeholder: "食物（或零食）：\n书籍和杂志：\n歌曲：",
            maxlength: 300,
            "show-count": ""
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            _createVNode(_component_a_select, {
              value: _ctx.formState.string[22],
              "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formState.string[22]) = $event)),
              mode: "tags",
              options: _ctx.blackContact,
              placeholder: "选择/输入(非分手拉黑阶段无需填写)",
              maxlength: 50
            }, null, 8, ["value", "options"])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createVNode(_component_a_select, {
              value: _ctx.formState.string[23],
              "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formState.string[23]) = $event)),
              mode: "tags",
              options: _ctx.contact,
              placeholder: "选择/输入",
              maxlength: 50
            }, null, 8, ["value", "options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _hoisted_41,
          _createVNode(_component_a_textarea, {
            rows: 1,
            value: _ctx.formState.string[24],
            "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formState.string[24]) = $event)),
            placeholder: "一共的约会次数：\n频率：",
            maxlength: 300,
            "show-count": ""
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _hoisted_43,
          _createVNode(_component_a_input, {
            value: _ctx.formState.string[25],
            "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formState.string[25]) = $event)),
            maxlength: 100,
            "show-count": ""
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_44, [
          _hoisted_45,
          _createVNode(_component_a_textarea, {
            rows: 1,
            value: _ctx.formState.string[26],
            "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formState.string[26]) = $event)),
            placeholder: "使用的沟通方式：\n沟通情况：",
            maxlength: 300,
            "show-count": ""
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _hoisted_47,
          _createVNode(_component_a_textarea, {
            rows: 4,
            value: _ctx.formState.string[27],
            "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formState.string[27]) = $event)),
            placeholder: "话题的深入程度：\n如：工作、生活、情趣爱好、童年会有、家庭生活、情感经历、人生观、情感经历、人生观、价值观、世界观、见面的话题等",
            maxlength: 300,
            "show-count": ""
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _hoisted_49,
          _createVNode(_component_a_textarea, {
            rows: 1,
            value: _ctx.formState.string[28],
            "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formState.string[28]) = $event)),
            placeholder: "哭过（几次）：\n是什么原因哭：",
            maxlength: 300,
            "show-count": ""
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _hoisted_52,
            _createVNode(_component_a_select, {
              value: _ctx.formState.string[29],
              "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.formState.string[29]) = $event)),
              mode: "tags",
              options: _ctx.touch,
              placeholder: "选择/输入",
              maxlength: 50
            }, null, 8, ["value", "options"])
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("span", null, [
              _createTextVNode("30.什么时候开始确立关系的："),
              _createElementVNode("b", null, _toDisplayString(_ctx.formState.string[30] == null
                ? ""
                : _ctx.timeago2Date(_ctx.formState.string[30]) + "前"), 1)
            ]),
            _createVNode(_component_a_date_picker, {
              value: _ctx.formState.string[30],
              "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.formState.string[30]) = $event))
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_54, [
          _hoisted_55,
          _createVNode(_component_a_input, {
            value: _ctx.formState.string[31],
            "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.formState.string[31]) = $event)),
            placeholder: "如有，请详细说明竞争者情况",
            maxlength: 200,
            "show-count": ""
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_56, [
          _hoisted_57,
          _createVNode(_component_a_input, {
            value: _ctx.formState.string[32],
            "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.formState.string[32]) = $event)),
            maxlength: 100,
            placeholder: "（情感、经济等等），如有，请列举：",
            "show-count": ""
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_58, [
          _hoisted_59,
          _createVNode(_component_a_select, {
            value: _ctx.formState.string[33],
            "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.formState.string[33]) = $event)),
            mode: "tags",
            options: _ctx.purImpression,
            placeholder: "选择/输入",
            maxlength: 50
          }, null, 8, ["value", "options"])
        ]),
        _createElementVNode("div", _hoisted_60, [
          _hoisted_61,
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              _createElementVNode("p", null, [
                _hoisted_62,
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: _ctx.formStateOut.date,
                  "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.formStateOut.date) = $event)),
                  style: {"width":"200px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, {
                      value: _ctx.todayUpAndWeek('3')
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.todayUpAndWeek("3")), 1)
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createVNode(_component_a_select_option, {
                      value: _ctx.todayUpAndWeek('4')
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.todayUpAndWeek("4")), 1)
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createVNode(_component_a_select_option, {
                      value: _ctx.todayUpAndWeek('5')
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.todayUpAndWeek("5")), 1)
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createVNode(_component_a_select_option, {
                      value: _ctx.todayUpAndWeek('6')
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.todayUpAndWeek("6")), 1)
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createVNode(_component_a_select_option, {
                      value: _ctx.todayUpAndWeek('7')
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.todayUpAndWeek("7")), 1)
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _createElementVNode("p", null, [
                _hoisted_63,
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: _ctx.formStateOut.time,
                  "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.formStateOut.time) = $event)),
                  style: {"width":"150px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "13：00-14：00" }, {
                      default: _withCtx(() => [
                        _createTextVNode("13：00-14：00")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "19：00-20：00" }, {
                      default: _withCtx(() => [
                        _createTextVNode("19：00-20：00")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "20：00-21：00" }, {
                      default: _withCtx(() => [
                        _createTextVNode("20：00-21：00")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "21：00-22：00" }, {
                      default: _withCtx(() => [
                        _createTextVNode("21：00-22：00")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "22：00-23：00" }, {
                      default: _withCtx(() => [
                        _createTextVNode("22：00-23：00")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ])
            ]),
            _: 1
          }),
          _hoisted_64
        ]),
        _createElementVNode("div", _hoisted_65, [
          _createVNode(_component_a_button, {
            onClick: _ctx.onShow,
            style: {"background-color":"#0072ff","height":"auto","width":"100%","color":"#fff"}
          }, {
            default: _withCtx(() => [
              _createTextVNode("发送求助邮件")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["model", "label-col", "wrapper-col"])
  ]))
}